import React from "react";
import CourseDetailPage from "../components/Courses/Shared/CourseDetailPage";

const DigitalElectronics = () => {
  const courseData = {
    backLink: "/course/computer-engineering",
    heroTitle: "Digital Electronics",
    heroSubtitle: "Master the fundamental principles of digital circuit design and electronic components",
    heroImage: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    introParagraphs: [
      "Digital Electronics is the foundation of modern computer systems and electronic devices. This comprehensive course introduces you to the fundamental principles of digital circuit design, logic gates, and electronic components that form the backbone of all digital systems.",
      "You'll learn about binary number systems, Boolean algebra, logic gates, combinational and sequential circuits, and how to design and analyze digital systems. The course combines theoretical knowledge with hands-on laboratory work using modern digital design tools and simulation software.",
      "Through practical projects and real-world applications, you'll gain the skills needed to design, implement, and troubleshoot digital circuits. This course prepares you for advanced topics in computer engineering and provides a solid foundation for careers in electronics and embedded systems."
    ],
    learningOutcomes: [
      "Understand binary number systems and digital logic",
      "Master Boolean algebra and logic gate operations",
      "Design combinational logic circuits",
      "Implement sequential circuits and flip-flops",
      "Work with digital design tools and simulation software",
      "Analyze and troubleshoot digital circuits",
      "Understand memory systems and storage devices",
      "Design arithmetic and logic units (ALUs)",
      "Apply digital electronics principles to real-world problems",
      "Prepare for advanced computer engineering courses"
    ],
    careerPaths: [
      {
        title: "Digital Design Engineer",
        description: "Design and develop digital circuits and systems for various applications.",
        color: "bg-gradient-to-r from-blue-500 to-purple-600"
      },
      {
        title: "Embedded Systems Engineer",
        description: "Develop embedded systems and microcontrollers for IoT and automation applications.",
        color: "bg-gradient-to-r from-green-500 to-teal-600"
      },
      {
        title: "Hardware Engineer",
        description: "Design and test computer hardware components and systems.",
        color: "bg-gradient-to-r from-orange-500 to-red-600"
      },
      {
        title: "Electronics Technician",
        description: "Install, maintain, and repair electronic equipment and digital systems.",
        color: "bg-gradient-to-r from-pink-500 to-rose-600"
      },
      {
        title: "FPGA Engineer",
        description: "Design and program Field-Programmable Gate Arrays for specialized applications.",
        color: "bg-gradient-to-r from-indigo-500 to-blue-600"
      },
      {
        title: "Test Engineer",
        description: "Develop and implement testing procedures for digital electronic systems.",
        color: "bg-gradient-to-r from-purple-500 to-indigo-600"
      }
    ],
    prerequisites: "Basic mathematics and physics knowledge",
    duration: "14 weeks",
    level: "Beginner to Intermediate"
  };

  return <CourseDetailPage {...courseData} />;
};

export default DigitalElectronics;

